import {uploadFile} from "../../service/uploaderService/UploaderService";
import {BaseService} from "../../base/BaseService";
import {HttpClient} from "../../service/httpClient/HttpClient";

export class FileManagerService {


    constructor() {
        this.httpClient = new HttpClient()
    }

    uploadImageToServer(imageFile, publishStatus, setHideImageUploadLoading, setProgressImage, setBufferImage, fileManagerType) {
        return new Promise((resolve, reject) => {
            uploadFile(
                imageFile,
                fileManagerType.uploadUrl,
                setProgressImage,
                setBufferImage,
                setHideImageUploadLoading,
                {
                    "public-status": publishStatus
                }
            )
                .then(resolve).catch(reject)
        })
    }

    getImages(selectedFileMangerType, page, size = 15) {

        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `buckets/${selectedFileMangerType.id}/files`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    deleteFile(id, fileManagerUrl) {

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "application/json",
                process.env.REACT_APP_BASE_URL
            )
                .delete(
                    `${fileManagerUrl}/${id}`,
                ).then(resolve).catch(reject)
        })

    }

    getPublicUrl(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `files/${id}/urls/public`,
            ).then(resolve).catch(reject)
        })
    }

    getFiles(url, page, size) {
        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "application/json",
                process.env.REACT_APP_BASE_URL
            ).get(
                url,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }


    uploadVideoToServer(file, setUploadPercent, handleHideLoading, url) {
        return new Promise((resolve, reject) => {
            uploadFile(
                file,
                url,
                setUploadPercent,
                () => {
                },
                handleHideLoading,
            ).then(resolve).catch(reject)
        })
    }


    uploadImageFile(imageFile, handleHideLoading, setUploadPercent, uploadUrl) {
        return new Promise((resolve, reject) => {
            uploadFile(
                imageFile,
                uploadUrl,
                setUploadPercent,
                () => {
                },
                handleHideLoading,
            ).then(resolve).catch(reject)
        })
    }
}